<template>
    <div>
        <div class="header">
            <design-2021-colorpicker
                class="apprentice-color-picker"
                id="slide-color-input"
                v-if="slideIn.type !== 2"
                :style="cssColorVar"
                :color="slide.color"
                @input="updateSlideColor">
            </design-2021-colorpicker>

            <b-button
                class="float-right btn-remove"
                @click="deleteSlide"
                variant="danger-icon-only">
            </b-button>
        </div>

        <design-2021-presentation-edit-text-type-component
            v-if="slideIn.type === 1"
            ref="text-slide"
            @update-slide-value="updateSlideValue"
            :slide-in="slide">
        </design-2021-presentation-edit-text-type-component>

        <design-2021-presentation-edit-video-type-component
            v-else-if="slideIn.type === 2"
            ref="video-slide"
            :slide-in="slide">
        </design-2021-presentation-edit-video-type-component>

        <design-2021-presentation-edit-list-type-component
            v-else-if="slideIn.type === 3"
            ref="list-slide"
            @presentation-updated="updatePresentation"
            :slide-in="slide">
        </design-2021-presentation-edit-list-type-component>

        <design-2021-presentation-edit-list-named-type-component
            v-else-if="slideIn.type === 4"
            ref="named-list-slide"
            @presentation-updated="updatePresentation"
            :slide-in="slide">
        </design-2021-presentation-edit-list-named-type-component>

        <b-button
            class="btn-save-slide"
            @click="saveSlide"
            variant="primary">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-edit-slide-component',
    props: {
        slideIn: {
            type: Object,
            request: true,
        },
    },
    data() {
        return {
            slide: this.slideIn,
        };
    },
    methods: {
        updateSlideColor(value) {
            this.slide.color = value;
            if (this.slideIn.type === 1) {
                this.$refs['text-slide'].changeEditorBackground();
            }
        },
        updateSlideValue(newValue) {
            this.slide.value = newValue;
        },
        saveSlide() {
            this.axios.post(this.routes.presentationSlideUpdate(this.slideIn.id), this.slide).then(
                (response) => {
                    this.$emit('presentation-updated', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deleteSlide() {
            this.axios.delete(this.routes.presentationSlideDelete(this.slideIn.id)).then(
                (response) => {
                    this.$emit('presentation-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        updatePresentation(presentation) {
            this.$emit('presentation-updated', presentation);
        },
    },
    computed: {
        cssColorVar() {
            let color = '#000000';

            if (this.slide.color) {
                color = this.slide.color;
            }

            return {
                '--picker-color': color,
            };
        },
    },
    watch: {
        slideIn: {
            handler(newVal, oldVal) {
                this.slide = newVal;
            },
            deep: true, // Watch for deep changes in the object
            immediate: true, // Trigger the watcher immediately on component creation
        },
    },
};
</script>

<style scoped lang="scss">
.header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: $grid-gutter-width;
}

.color-picker {
    width: auto;

    ::v-deep input.form-control {
        height: 49px;
        border: 1px solid var(--picker-color);
        border-right: 0;
        top: 1px;
    }
}

.btn-save-slide {
    margin-top: map-get($grid-gutter-spacing, 'sixty');
    position: relative;
    left: calc(100% - 93px);
}
</style>
